<template>
  <b-row v-if="categories.length" class="categories-container">
    <b-row>
      <div
        v-for="(item, index) in categories"
        :key="'see-' + index"
        class="category-container col-md-1-10"
      >
        <div class="category">
          <nuxt-link :to="{ path: item.url }">
            <img class="category-icon w-100" :src="item.icon" :alt="item.name" />
            <h2 class="category-name">{{ item.name }}</h2>
          </nuxt-link>
        </div>
      </div>

      <div v-show="!showMore" class="category-container col-md-1-10">
        <div v-b-toggle.collapse-2 @click="showCategories()">
          <div class="category seemore-container" :style="{ backgroundColor: getExperienceColor }">
            <span class="seemore">+</span>
            <p class="category-name see-more-text">
              {{ $t('categories.main.sector.button') }}
            </p>
          </div>
        </div>
      </div>

      <b-collapse id="collapse-2" :visible="false">
        <div
          v-for="(item, index) in moreCategories"
          :key="'more-' + index"
          class="category-container col-md-1-10"
        >
          <div class="category">
            <nuxt-link :to="{ path: item.url }">
              <img class="category-icon w-100" :src="item.icon" :alt="item.name" />
              <h2 class="category-name">{{ item.name }}</h2>
            </nuxt-link>
          </div>
        </div>

        <div v-show="showMore" class="category-container col-md-1-10">
          <div v-b-toggle.collapse-2 @click="showCategories()">
            <div
              class="category seemore-container"
              :style="{ backgroundColor: getExperienceColor }"
            >
              <span class="seemore">-</span>
              <p class="category-name see-more-text">see less</p>
            </div>
          </div>
        </div>
      </b-collapse>
    </b-row>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    categoriesList: {
      type: Array,
      required: true
    },
    categoriesLimit: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      showMore: true,
      categories: [],
      auxCategories: [],
      moreCategories: []
    };
  },
  computed: {
    ...mapGetters('experience', ['getExperienceColor'])
  },
  created() {
    this.showCategories();
  },
  methods: {
    showCategories() {
      this.showMore = !this.showMore;
      const actualLimit = !this.showMore ? this.categoriesLimit : this.categoriesLimit + 1;
      this.categories = this.categoriesList.slice(0, actualLimit);
      this.moreCategories = this.categoriesList.slice(
        this.categories.length + 1,
        this.categoriesList.length
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.categories-container {
  margin: 70px 0px 100px;
}

.category-container {
  margin: 5px 0px;
}

.category {
  border-radius: 9px;
  padding: 10px;
  opacity: 1;
  margin: 0px 5px;
}

.category:hover {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  cursor: pointer;
}

.category-icon {
  padding: 5px 0px;
  display: flex;
  justify-content: center;
  height: 53px;
  @include sm {
    height: 60px;
  }
}

.category-name {
  width: 100%;
  height: 43px;
  font-size: 0.75em;
  font-weight: 400;
  text-align: center;
  letter-spacing: 0.15px;
  color: #4d4d4d;
  opacity: 1;
  margin: 5px 0px;
  padding: 5px;
  display: flex;
  justify-content: center;
  line-height: 1.5;
}

.seemore-container {
  margin: 0px 5px;
  height: 100px;
}

.seemore {
  font-size: 22px;
  height: 39px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.see-more-text {
  color: #fff;
}

.seeCategories:active {
  -moz-transition: height 0.4s;
  -ms-transition: height 0.4s;
  -o-transition: height 0.4s;
  -webkit-transition: height 0.4s;
  transition: height 0.4s;
  height: 0;
  overflow: hidden;
}

.col-md-1-10 {
  position: relative;
  min-height: 1px;
  width: 10%;
  float: left;
  @include lg {
    width: 25%;
    padding: 10px;
  }
  @include sm {
    width: 50%;
    padding: 20px;
  }
}
</style>
